import { Box } from '@mui/material';
import { ComponentProps } from 'react';

export const getVideoRoomBoxStyle: () => ComponentProps<typeof Box> = () => ({
  height: 'calc(100dvh - 50px)',
  width: '100vw',
});
